export default "__VITE_ASSET__BIGuOzhc__"